import hexRgb from "hex-rgb";

export const valueToPx = (value: any) => {

    if (Number.isInteger(value)) {
        return value + "px";
    }

    if (typeof value === 'string') {
        const newValue = parseInt(value, 10);

        return newValue + "px";
    }

    return value;
};

export const asFormData = (obj: Record<any, any>) => {
    const formData = new FormData();

    for (const key in obj) {
        if (Array.isArray(obj[key])) {
            obj[key].forEach(value => formData.append(key + '[]', value));
        } else {
            let value = obj[key];

            if (value === null) {
                value = "";
            }

            formData.append(key, value);
        }
    }

    return formData;
};

export const isObjectEmpty = (objectName: any) => {
    return (
        objectName &&
        Object.keys(objectName).length === 0 &&
        objectName.constructor === Object
    );
};

export function hexToRgbForTailwindConfig(hex: string) {
    try {
        const values = hexRgb(hex, { format: "array" }); // This returns [r,g,b,alpha]
        values.pop(); // remove alpha (handled by tailwind)

        return values.join(","); // Return as a comma-delimited string. Tailwind then makes into rgb(r,g,b, {a})
    } catch (_) {
        return hex;
    }
}

export function isFunction(value: any) {
    return typeof value === "function";
}

export function scrollToTop() {
    window.scrollTo(0, 0);
}

export function isNullOrEmptyString(value: any) {
    return value === null || value === "";
}